import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { loadHeaderStickymenus } from "../../assets/js/main";
import IASLogo from "../../assets/images/logo.png";
import Menu from "@mui/icons-material/Menu";
import DrawerMenu from "./DrawerMenus";
import headerData from "../../data/headermenus.json";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import $ from "jquery";

const PREFIX = "Header";
const classes = {
  CollapseContainer: `${PREFIX}-CollapseContainer`,
  wrapperInner: `${PREFIX}-wrapperInner`,
  subMenuLists: `${PREFIX}-subMenuLists`,
  submenuList: `${PREFIX}-submenuList`,
  headerLinksContainer: `${PREFIX}-headerLinksContainer`,
  hideLess960: `${PREFIX}-hideLess960`,
  showGreat960: `${PREFIX}-showGreat960`,
  productMenuContainer: `${PREFIX}-productMenuContainer`,
  homePageTitledesc: `${PREFIX}-homePageTitledesc`,
  productItemBlock: `${PREFIX}-productItemBlock`,
  navLink: `${PREFIX}-navLink`,
  navLinkActive: `${PREFIX}-navLinkActive`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.CollapseContainer}`]: {
    position: "relative",
    bottom: "4.5em",
    border: "1px solid #3e3e3e2e",
    borderRight: "none",
    borderLeft: "none",
  },
  [`& .${classes.wrapperInner}`]: {
    textAlign: "right",
  },
  [`& .${classes.subMenuLists}`]: {
    display: "inline-flex",
    margin: "10px 3em 10px 0",
  },
  [`& .${classes.submenuList}`]: {
    margin: "0 2em",
    listStyle: "none",
  },
  [`& .${classes.headerLinksContainer}`]: {
    display: "flex",
    justifyContent: "space-between",
  },
  [`& .${classes.hideLess960}`]: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  [`& .${classes.showGreat960}`]: {
    [theme.breakpoints.down("md")]: {
      display: "block",
      padding: 10,
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  [`& .${classes.productMenuContainer}`]: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  [`& .${classes.productItemBlock}`]: {
    minHeight: "2em",
    fontFamily: "AvenirLTStd-Book",
    letterSpacing: "0.21px",
    color: "#707070",
    width: "75%",
    margin: "10px 0",
  },
}));

const Header = () => {
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeLink, setActiveLink] = useState(null);
  const location = useLocation();

  useEffect(() => {
    loadHeaderStickymenus();
    openProductMenus();
    window.scrollTo(0, 0); 
  }, [location]);

  const openProductMenus = () => {
    const pageAccessedByReload = window.performance
      .getEntriesByType("navigation")
      .map((nav) => nav.type)
      .includes("reload");
    $(".header-nav li").hover(function () {
      if ($(this).data("id") === "our-products") {
        $("#etlMenu").toggle();
        $(".main-header.large-screen").toggleClass("active-product-menu-open");
      } else if ($(this).data("id") === "ops-products") {
        $("#opsMenu").toggle();
        $(".main-header.large-screen").toggleClass("active-product-menu-open");
      }
    });
    if (pageAccessedByReload) {
      if ($(this).data("id") === "our-products") {
        $("#etlMenu").toggle();
        $(".main-header.large-screen").toggleClass("active-product-menu-open");
      } else if ($(this).data("id") === "ops-products") {
        $("#opsMenu").toggle();
        $(".main-header.large-screen").toggleClass("active-product-menu-open");
      }
    }
  };

  const lastHash = useRef("");

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1);
    }

    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        document
          .getElementById(lastHash.current)
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
        lastHash.current = "";
      }, 100);
    }
  }, [location]);

  const openSubmenus = (status) => {
    setSubMenuOpen(!status);
  };

  const toggleDrawer = (open) => () => {
    setOpen(open);
  };

  const handleClick = (id) => {
    setActiveLink(id);
  };

  return (
    <StyledBox>
      <header
        id="header"
        role="banner"
        className={["main-header large-screen", classes.hideLess960].join(" ")}
      >
        <div className="header-inner">
          <div className="header-logo">
            <Link to="/">
              <img src={IASLogo} alt="Creative Juiz" width="120" height="120" />
            </Link>
          </div>
          <nav className="header-nav">
            <ul>
              {headerData.map((header) => (
                <li key={header.id} data-id={header.id}>
                  <NavLink
                    to={header.href}
                    className={({ isActive }) => (isActive ? "is-active" : "")}
                    onClick={() => handleClick(header.id)}
                  >
                    <span>{header.text}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            <NavLink
              to={"/about#contact"}
              className={"border-menu"}
              style={{ height: 34 }}
            >
              {"Contact Us"}
            </NavLink>
          </div>
        </div>
      </header>
      <header
        id="header"
        role="banner"
        className={["main-header", classes.showGreat960].join(" ")}
      >
        <div className="header-inner">
          <div className="header-logo" style={{ float: "left" }}>
            <Link to="/">
              <img src={IASLogo} alt="Creative Juiz" width="120" height="120" />
            </Link>
          </div>
          <div className={classes.showGreat960}>
            <Menu
              onClick={toggleDrawer(true)}
              style={{ cursor: "pointer", position: "relative", top: 10 }}
            />
          </div>
          <DrawerMenu
            toggleDrawer={toggleDrawer}
            open={open}
            headerData={headerData}
            location={location}
          />
        </div>
      </header>
    </StyledBox>
  );
};

export default Header;
